import { UrlConfig } from 'config';
import { MergeModel, MergeSummaryModel, PaginationModel } from 'models';
import { RawMergeData, RawMergeDetailData } from 'models/merge/types';
import { ProcessStatus } from 'models/types';
import { ApiResponse } from 'models/Api/ApiResponse';
import { AjaxService } from 'services';
import { JSONObject } from 'models/Api/types';
import { RawPaginationData } from 'models/Pagination/Pagination';

export class MergeApiClient {
  public static async getMergeById(id: string): Promise<MergeModel> {
    const url = UrlConfig.MERGE.MERGE_BY_ID + `${id}`;
    const response: ApiResponse<RawMergeDetailData> = await AjaxService.getData(url);
    const merge = new MergeModel(response.data);
    return merge;
  }

  public static async getAllMerges(): Promise<MergeSummaryModel[]> {
    const url = UrlConfig.MERGE.MERGE_ALL;
    const response: ApiResponse<RawMergeData[]> = await AjaxService.getData(url);
    const mergeList = response.data.map(rawMerge => new MergeSummaryModel(rawMerge));
    return mergeList;
  }

  public static async getMergesByStatus(status: ProcessStatus): Promise<MergeSummaryModel[]> {
    const url = UrlConfig.MERGE.MERGE_BY_STATUS + status;
    const response: ApiResponse<RawMergeData[]> = await AjaxService.getData(url);
    const mergeList = response.data.map(rawMerge => new MergeSummaryModel(rawMerge));
    return mergeList;
  }

  public static async getDetailedStatusMerges(status: ProcessStatus): Promise<PaginationModel<MergeModel>> {
    const url = UrlConfig.MERGE.MERGE_DETAILED_STATUS + `${status}`;
    const response: ApiResponse<RawPaginationData<RawMergeDetailData>> = await AjaxService.getData(url);
    const paginatedResponse: PaginationModel<RawMergeDetailData> = new PaginationModel(response.data);
    const formattedMerges = paginatedResponse.data.map((rawMerge: RawMergeDetailData) => new MergeModel(rawMerge));
    const formattedPaginatedResponse: PaginationModel<MergeModel> = new PaginationModel({ ...response.data, data: formattedMerges, fetched: true });
    return formattedPaginatedResponse;
  }

  public static async createMerge(payload: JSONObject): Promise<string> {
    const url = UrlConfig.MERGE.MERGE_CREATE;
    const response: ApiResponse<string> = await AjaxService.postData(url, payload);
    return response.data;
  }

  public static async approveMerge(mergeId: string): Promise<string> {
    const url = UrlConfig.MERGE.MERGE_APPROVE;
    await AjaxService.postData(url, { merge_id: mergeId });
    return mergeId;
  }

  public static async rejectMerge(mergeId: string): Promise<string> {
    const url = UrlConfig.MERGE.MERGE_REJECT;
    await AjaxService.postData(url, { merge_id: mergeId });
    return mergeId;
  }
}
